/**
 * Auto Insight Panel.
 * Main component orchestrating all auto insight cards.
 */

import React from 'react';
import type { AutoInsightResult } from '@excel-ai-studio/shared';
import { DatasetOverviewCard } from './DatasetOverviewCard';
import { NumericStatsCard } from './NumericStatsCard';
import { CategoryStatsCard } from './CategoryStatsCard';
import { InsightCard } from './InsightCard';
import { ChartSuggestionCard } from './ChartSuggestionCard';
import { AISummaryCard } from './AISummaryCard';

interface AutoInsightPanelProps {
  readonly result: AutoInsightResult;
}

export const AutoInsightPanel: React.FC<AutoInsightPanelProps> = ({ result }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* Overview */}
      <DatasetOverviewCard analysis={result.analysis} />

      {/* Statistics */}
      {result.numericStats.length > 0 && <NumericStatsCard stats={result.numericStats} />}
      {result.categoryStats.length > 0 && <CategoryStatsCard stats={result.categoryStats} />}

      {/* Insights */}
      {result.insights.length > 0 && <InsightCard insights={result.insights} />}

      {/* Chart Suggestions */}
      {result.chartSuggestions.length > 0 && <ChartSuggestionCard suggestions={result.chartSuggestions} />}

      {/* AI Summary */}
      {result.aiSummary && <AISummaryCard summary={result.aiSummary} />}

      {/* Warnings */}
      {result.warnings.length > 0 && (
        <div
          style={{
            backgroundColor: '#fff4ce',
            border: '1px solid #ffb900',
            borderRadius: '4px',
            padding: '12px',
            fontSize: '12px',
            color: '#333',
          }}
        >
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>⚠️ Avertissements</div>
          {result.warnings.map((warning, idx) => (
            <div key={idx}>• {warning}</div>
          ))}
        </div>
      )}
    </div>
  );
};
